import React, { FC } from 'react'
import s from "./ProjectionDropdown.module.scss"
import { CloseIcon } from '../../assets/svg/CloseIcon';


export interface CameraSetting {
  label: string;
  unit: string;
  min: number | string;
  max: number | string;
  defaultValue: number;
  step?: number;
}

export interface ProjectionType {
  id: string;
  name: string;
  isParent?: boolean;
  children?: string[];
}

export interface ProjectionDropdownProps {
  projections: ProjectionType[];
  selectedProjection: string;
  onProjectionChange: (projectionId: string) => void;
  onClose?: () => void;
  hasProducts?: boolean;
}

export const ProjectionDropdown: FC<ProjectionDropdownProps> = ({ 
  projections, 
  selectedProjection,
  onProjectionChange,
  onClose,
  hasProducts = true
}) => {
  const handleProjectionChange = (projectionId: string) => {
    // Allow perspective always, orthographic only if products exist
    if (projectionId === 'perspective' || hasProducts) {
      onProjectionChange(projectionId);
    }
  };

  return (
    <div className={s.container}>
      <div className={s.cameraSetting}>
        <span>Projection</span>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <CloseIcon />
        </div>
      </div>
      <div className={s.projectionsList}>
        {projections.filter(p => p.id === 'perspective').map(p => (
          <div
            key={p.id}
            className={`${s.projectionItem} ${selectedProjection === p.id ? s.parentItem : ''}`}
            onClick={() => handleProjectionChange(p.id)}
          >
            <div className={s.radioButton}>
              {selectedProjection === p.id && <div className={s.radioButtonInner}></div>}
            </div>
            <span>{p.name}</span>
          </div>
        ))}
        <div className={`${s.orthographic} ${!hasProducts ? s.disabled : ''}`} key="orthographic-label">
          <span>{projections.find(p => p.id === 'orthographic')?.name}</span>
        </div>
        {projections.filter(p => p.id !== 'perspective' && p.id !== 'orthographic').map(p => (
          <div
            key={p.id}
            className={`${s.projectionItem} ${selectedProjection === p.id ? s.parentItem : ''} ${!hasProducts ? s.disabled : ''}`}
            onClick={() => handleProjectionChange(p.id)}
          >
            <div className={s.radioButton}>
              {selectedProjection === p.id && <div className={s.radioButtonInner}></div>}
            </div>
            <span>{p.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
